<template>
  <div class="main-wrapper">
    <el-row :gutter="20">
      <el-col :span="20">
        <el-form :inline="true" :model="formInline">
          <el-form-item label="关键字">
            <el-input v-model="formInline.keyword" placeholder="关键字"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="btnSearchClick">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="4" style="text-align: right">
        <el-button type="warning" @click="btnDownloadClick">下载</el-button>
        <el-button type="warning" @click="btnCheckClick">审查</el-button>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="6" v-for="image in images" :key="image.id">
        <el-image
          style="width: 100%; min-height: 120px; max-height: 220px; margin-bottom: 15px"
          :src="getSmallUrl(image)"
          :preview-src-list="[getRegularUrl(image)]"
          v-on:error="onError(image)"
        >
          <template #error>
            <div class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </template>
          <template #placeholder>
            <el-skeleton style="width: 100%" :loading="true" animated>
              <template #template>
                <el-skeleton-item variant="image" style="width: 100%; height: 180px" />
              </template>
            </el-skeleton>
          </template>
        </el-image>
      </el-col>
    </el-row>

    <el-row style="margin: 10px">
      <el-col :span="24" align="center">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="formInline.currentPage"
          :page-size="formInline.limit"
          layout="total, prev, pager, next, jumper"
          :total="count"
        ></el-pagination>
      </el-col>
    </el-row>

    <el-row>
      <el-divider></el-divider>
      <div style="height: 10px"></div>

      <el-button type="primary" @click="btnDeleteClick">清空日志</el-button>
    </el-row>
  </div>
</template>

<script lang="ts">
import { IImage } from '@/types/models';
import { defineComponent } from 'vue';
import utils from '@/utils';
import api from '@/api/admin/images';

interface IForm {
  keyword: string;
  currentPage: number;
  offset: number;
  limit: number;
}

interface IState {
  images: IImage[];
  count: number;
  formInline: IForm;
}

export default defineComponent({
  data() {
    return {
      images: [],
      count: 0,
      formInline: {
        keyword: '',
        currentPage: 1,
        offset: 0,
        limit: 16,
      },
    } as IState;
  },
  methods: {
    apiGet() {
      api.get(this.formInline, (res) => {
        this.images = res.images;
        this.count = res.count;
      });
    },

    apiDelete(id: number) {
      api.delete(id, (res) => {
        if (!res) return;

        this.apiGet();
      });
    },

    getSmallUrl(image: IImage) {
      return `https://images.sscms.com/${image.smallUrl}`;
    },

    getRegularUrl(image: IImage) {
      return `https://images.sscms.com/${image.regularUrl}`;
    },

    btnDeleteClick(image: IImage) {
      utils.alertDelete(
        {
          title: `删除图片${image.imageId}`,
          text: '此操作将会删除图片，确定吗？',
          button: '删 除',
        },
        () => {
          this.apiDelete(image.id);
        },
      );
    },

    btnLogView(logId: number) {
      utils.pageOpen('error', {
        logId,
      });
    },

    btnSearchClick() {
      this.formInline.currentPage = 1;
      this.formInline.offset = 0;

      api.get(this.formInline, (res) => {
        this.images = res.images;
        this.count = res.count;
      });
    },

    btnDownloadClick() {
      api.download((res) => {
        if (!res) return;

        utils.success('下载完毕！');
        this.handleCurrentChange(1);
      });
    },

    onError(image: IImage) {
      console.log(image.id);
    },

    btnCheckClick() {
      api.check((res) => {
        if (!res) return;

        utils.success('审查完毕！');
        this.handleCurrentChange(1);
      });
    },

    handleCurrentChange(val: number) {
      this.formInline.currentPage = val;
      this.formInline.offset = this.formInline.limit * (val - 1);

      api.get(this.formInline, (res) => {
        this.images = res.images;
        this.count = res.count;
        utils.scrollTop();
      });
    },
  },
  mounted() {
    this.apiGet();
  },
});
</script>
